import { getMessages } from '../../../../../store/constants';

export const CARD_SECTION_DATES = getMessages().getText('card_form_section_dates');
export const CARD_SECTION_DATES_MILESTONE = getMessages().getText('card_form_section_dates_milestone');
export const CARD_DATES_EPIC_TOOLTIP = 'Epic\'s dates are only determined by subcards';
export const CARD_AUTO_START_DATE_SHOW_COUNT = 2;
